import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar as MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ControltowerService } from 'src/app/services/dashboards/controltower.service';

@Component({
  selector: 'neoris-modal-reporting-fields',
  templateUrl: './modal-reporting-fields.component.html',
  styleUrls: ['./modal-reporting-fields.component.css']
})
export class ModalReportingFieldsComponent implements OnInit {
  arrayReasons:any[]=[]
  private onLanChange:Subscription
  strTranslate:string
  IsReadonly:boolean = true
  requestReportFields:any={}
  textvalue:string=''
  selectedData:any[]=[]

  reportFieldsServices:UntypedFormGroup = new UntypedFormGroup({})
  
  constructor(public dialogRef: MatDialogRef<ModalReportingFieldsComponent>,
    private controltowerservice:ControltowerService,
    private translate:TranslateService,
    private _snackBar:MatSnackBar,
    private route: Router,
    private fb: UntypedFormBuilder ) { 
      this.reportFieldsServices = this.fb.group({
        reason: ( ['', [Validators.required]])
      
    
      });
    
    }

    get reason(){
      return this.reportFieldsServices.controls
    }
   

  ngOnInit(): void {
    this.onLanChange = this.translate.onLangChange.subscribe(s => {
      console.log("idioma",s.lang)
      this.strTranslate = s.lang != undefined ? s.lang : "en";
      let succesGeneric = this.getGenericAtrributeValue(this.strTranslate)
    })

    console.log('ssss',this.strTranslate)
    if(this.strTranslate == undefined){
    let succesGeneric = this.getGenericAtrributeValue('en')
    }
  }

  close(){
    this.dialogRef.close()
  }

  async save(){
    this.requestReportFields.sourceDeviceIds = []
    this.selectedData = []

    console.log('form----->',this.reportFieldsServices.valid);

    const isFormValid: boolean = this.reportFieldsServices.valid
    
    console.log('formulario valido',this.reportFieldsServices.valid)

    this.selectedData = JSON.parse(localStorage.getItem('SelectedGridData'))

    for(let i= 0;i<=this.selectedData.length - 1;i++){
      this.requestReportFields.sourceDeviceIds.push(this.selectedData[i].sourceDeviceId)
    }
  
    let formData = this.reportFieldsServices.value

    this.requestReportFields.reasonId = this.reportFieldsServices.value.reason
    this.requestReportFields.reason = ""


    

    if(this.reportFieldsServices.valid){
      console.log('request final--->',this.requestReportFields)
      let success = await this.SaveReportFieldsServices(this.requestReportFields)
      
     console.log('result service save report--->',success)
    if(success.statusCode == 200 || success.message == "Success"){
      this.openSnackBar(this.translate.instant('ALERT_SUCCESS'),"OK")
      this.dialogRef.close()
      this.route.navigate(['/device-management'])
    }
    else{
      this.openSnackBar(this.translate.instant('ALERT_FAILED'),"FAILED")
      this.dialogRef.close()

    }
  }
  

  }

  openSnackBar(message: string, action: string) {
    if(action == 'OK'){
    this._snackBar.open(message, action, {
      duration: 5000,
      panelClass: ['blue-snackbar']
    });
  }
  else{
    this._snackBar.open(message, action, {
      duration: 5000,
      panelClass: ['blue-snackbar-false']
    });
  }
  }

  checkValue(event:any){

    this.IsReadonly = event == "Other" ? false : true

  }


  private async getGenericAtrributeValue(localCode:string): Promise<boolean> {
   

    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.getAttributeValue(localCode).subscribe(
        {
          next: (attribute: any={}) => {
            
            for(let i=0;i<= attribute.attributeTypes.length -1;i++){
              console.log('si entre')
              if(attribute.attributeTypes[i].id == 51){
                this.arrayReasons = attribute.attributeTypes[i].attributeValues

              }
            }
           
            
            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }


  private async SaveReportFieldsServices(request:any): Promise<any> {
    
    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.SaveReportFieldsServices(request).subscribe(
        {
          next: (report: any) => {
            console.log('respondio el save reporte--->:',report);
                                  
            resolve(report);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }

  

}
